import _ from 'lodash';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LICENSE_STATUS } from '@/licenseManagement/licenseManagement.constants';
import { useLicenseStatus } from '@/licenseManagement/licenseManagement.store';
import { getLicenseLink } from '@/main/routing.utilities';

/**
 * Hook to check license status and navigate to license page if invalid.
 * Note: License data is fetched at the app root level, this hook only checks status.
 */
export const useLicenseStatusCheck = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const licenseStatus = useLicenseStatus();

  useEffect(() => {
    if (!licenseStatus) {
      return;
    }

    const INVALID_STATUSES = [LICENSE_STATUS.NONE, LICENSE_STATUS.UNKNOWN, LICENSE_STATUS.EXPIRED];
    const currentPath = location.pathname;

    if (!_.includes(currentPath, 'license') && _.includes(INVALID_STATUSES, licenseStatus)) {
      navigate(getLicenseLink(), { replace: true });
    }
  }, [licenseStatus, location.pathname, navigate]);
};
